import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { systemCode } from '../../.';
import Loader from '../../common/Loader';
import { parseTournamentData } from '../../data/parseTournamentData';
import { getConfiguration } from '../../data/utils/configuration';
import { getPrincipaleOPrimoGruppo } from '../../data/utils/getPrincipaleOPrimoGruppo';
import { labels } from '../../data/labels';
import { PrematchContext } from '../Prematch';
import { TournamentContext } from './TournamentDataFetcher';
import TournamentLiveMatch from './TournamentLiveMatch';

function TournamentLiveMatches(props) {
    const prematchContext = React.useContext(PrematchContext);
    const tournamentContext = React.useContext(TournamentContext);

    function openLiveMatch(match) {
        prematchContext.openMatchFromTournament({
            ...tournamentContext.data,
            liveMatches: tournamentContext.liveMatches
        }, match);
    }

    const [state, setState] = useState({
        showLoader: true,
        error: false,
        aggregataFetch: getPrincipaleOPrimoGruppo(props.tournament.liveData.aggregate).idAggregata,
        data: null,
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        setData(data, error) {
            if (error === false) {
                this.update({showLoader: false, error, data});
            } else {
                this.update({showLoader: false, error, data: null});
            }
        },
        setShowLoader(showLoader, error) {
            this.update({showLoader, error});
        }
    });

    // The useEffect for fetching the data is only called once and would only always reference the first value of tournamentContext.
    // To make sure we always access the latest value, setLiveMatches is kept in sync with tournamentContext.
    const setLiveMatches = useRef(tournamentContext.setLiveMatches.bind(tournamentContext));
    useEffect(() => {
        setLiveMatches.current = tournamentContext.setLiveMatches.bind(tournamentContext);
    }, [tournamentContext]);

    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    state.setShowLoader(true, true);
                }
            }
        };
        function fetchTournamentData() {
            const url = getConfiguration()['api']['getTorneoCentraleLive'];
            const params = {
                systemCode,
                lingua: 'IT',
                hash: '',
                sportId: props.tournament.sportRef,
                categoryId: props.tournament.categoryRef,
                tournamentId: props.tournament.id,
                idAggregata: state.aggregataFetch
            }
            fetchData(url, params, function(response) {
                try {
                    if (response !== '' && response.avs.length > 0) {
                        const updatedData = parseTournamentData(prematchContext.data, response, props.tournament.uniqueId, params.idAggregata, true);
                        setLiveMatches.current(updatedData.events);
                    } else {
                        setLiveMatches.current(null);
                    }
                } catch (e) {
                    state.setShowLoader(true, true);
                    console.error(e);
                }
            });
        }

        fetchTournamentData();
        const intervalMillis = getConfiguration()?.lpo ?? 10000;
        const interval = setInterval(() => {
            fetchTournamentData();
        }, intervalMillis);
        
        return () => {
            didCancel = true;
            clearInterval(interval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
 
    useEffect(() => {
        state.setShowLoader(false, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tournamentContext.liveMatches]);

    if (state.showLoader) {
        return <Loader error={state.error} />
    }

    const liveMatches = tournamentContext.liveMatches;

    return (
        <>
            {liveMatches != null &&
                <div id="avvenimenti">
                    <span className="heading text-medium"><div className="badge-live mr-2"></div>{labels['prematch.tournament.live_events']}</span>
                    {liveMatches.map(match => {
                        return <TournamentLiveMatch key={match.uniqueId} match={match} aggregata={state.aggregataFetch} streaming={null} openLiveMatch={openLiveMatch} />
                    })}
                </div>
            }
        </>
    );
}

export default TournamentLiveMatches;